import { v4 as uuidv4 } from 'uuid';

function getMockArrayForSkeleton(quantity: number): string[] {
  return new Array(quantity).fill(0).map(() => uuidv4());
}

export default getMockArrayForSkeleton;
